"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { handleHeaderRewardsClickDL } from "./HeaderAnalyticsFunction";

interface HeaderPrimeProps {
  headerPrime?: {
    ctaText?: string;
    ctaLink?: string;
  };
}

const Prime: React.FC<HeaderPrimeProps> = ({ headerPrime }) => {
  const destinationUrl = headerPrime?.ctaLink ?? "";
  const ctaText = headerPrime?.ctaText || "Prime";

  const handleClick = () => {
    handleHeaderRewardsClickDL(destinationUrl, ctaText);
  };

  return (
    <BFLLink
      href={destinationUrl}
      aria-label={ctaText}
      onClick={handleClick}
      className="relative order-4 mx-0 my-0 min-w-[44.05px] md:min-w-[48.13px]! flex flex-col items-center md:pt-[14px] md:pb-[8px] hover:bg-[#001326] md:order-5 md:min-h-[37px] md:gap-[5px] md:min-w-[56.62px]!"
    >
      <i className="bf-icon-prime text-xl"></i>
      <span className="absolute top-[0px] md:top-[14px] right-[0px] md:right-[8px]! h-[8px] w-[8px] rounded-full bg-[#E8B100]"></span>
      <span className="hidden text-xs leading-[14px] md:!block font-normal [font-family:Rubik,Mukta,BalooThambi2,sans-serif]">{ctaText}</span>
    </BFLLink>
  );
};
export default Prime;
